/**
 * cp-blog-article-toc.js
 * Progressive-enhancement TOC pentru articolul de blog (template `article.cp`).
 * Scanează `.article-body h2`, le atribuie `id` (slug din text dacă lipsește),
 * populează `[data-cp-toc-list]` cu ancore și marchează link-ul activ la
 * scroll via IntersectionObserver. Rulează în light DOM — nu atinge web
 * components Horizon. Fără H2 în body → sidebar-ul rămâne ascuns (nu lasă
 * o coloană goală). Încărcat DOAR din sections/cp-blog-article-content.liquid
 * când `toc_mode == 'auto'` (via `script_tag`, deferred implicit).
 */
(function () {
  'use strict';

  function slugify(text) {
    var base = (text || '')
      .toString()
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return base || 'sectiune';
  }

  function uniqueId(base) {
    if (!document.getElementById(base)) return base;
    var i = 2;
    var candidate = base + '-' + i;
    while (document.getElementById(candidate)) {
      i += 1;
      candidate = base + '-' + i;
    }
    return candidate;
  }

  function headingText(heading) {
    // Exclude badge-ul .h2-icon (cifră decorativă) — TOC-ul își pune
    // propriul contor colorat, altfel cifra apare dublată.
    var clone = heading.cloneNode(true);
    var badges = clone.querySelectorAll('.h2-icon');
    for (var i = 0; i < badges.length; i++) {
      badges[i].parentNode.removeChild(badges[i]);
    }
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function initToc() {
    var body = document.querySelector('.article-body');
    var tocList = document.querySelector('[data-cp-toc-list]');
    var tocAside = document.querySelector('[data-cp-toc]');
    var tocTitle = tocAside ? tocAside.querySelector('.toc-title') : null;

    if (!body || !tocList || !tocAside || !tocTitle) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (headings.length === 0) return;

    var entries = [];
    var fragment = document.createDocumentFragment();

    headings.forEach(function (heading) {
      if (!heading.id) {
        heading.id = uniqueId(slugify(headingText(heading)));
      }

      var li = document.createElement('li');
      var link = document.createElement('a');
      link.setAttribute('href', '#' + heading.id);
      link.textContent = headingText(heading);
      li.appendChild(link);
      fragment.appendChild(li);

      entries.push({ heading: heading, link: link });
    });

    tocList.appendChild(fragment);
    tocAside.hidden = false;

    var wrap = tocAside.closest('.article-wrap');
    if (wrap) wrap.classList.add('has-toc');

    // Toggle jos-fixat pe mobil (bara rămâne vizibilă, lista se extinde în sus).
    // Pe desktop clasa nu are efect vizual (.toc-card e sticky, nu fixed).
    tocTitle.setAttribute('role', 'button');
    tocTitle.setAttribute('tabindex', '0');
    tocTitle.setAttribute('aria-expanded', 'false');

    var setOpen = function (open) {
      tocAside.classList.toggle('is-open', open);
      tocTitle.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    tocTitle.addEventListener('click', function () {
      setOpen(!tocAside.classList.contains('is-open'));
    });

    tocTitle.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setOpen(!tocAside.classList.contains('is-open'));
      }
    });

    tocList.addEventListener('click', function (event) {
      if (event.target.closest('a')) {
        setOpen(false);
      }
    });

    if (!('IntersectionObserver' in window)) return;

    var setActive = function (targetHeading) {
      entries.forEach(function (entry) {
        entry.link.classList.toggle('active', entry.heading === targetHeading);
      });
    };

    var observer = new IntersectionObserver(
      function (observedEntries) {
        var visible = observedEntries.filter(function (e) {
          return e.isIntersecting;
        });
        if (visible.length === 0) return;
        visible.sort(function (a, b) {
          return a.boundingClientRect.top - b.boundingClientRect.top;
        });
        setActive(visible[0].target);
      },
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );

    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToc);
  } else {
    initToc();
  }
})();
